import * as Sentry from '@sentry/react';
import { version } from '../../package.json';

const getSentryOptions = (): Sentry.BrowserOptions => {
  let environment = 'dev';
  switch (window.location.hostname) {
    case 'bestill.rikstv.no':
      environment = 'prod';
      break;
    case 'bestill.uat.rikstv.no':
      environment = 'uat';
      break;
  }
  return {
    dsn: 'https://c6b6d02950cb4c3ba6939ee94e412307@o575998.ingest.sentry.io/5743151',
    release: version,
    enabled: environment !== 'dev',
    environment,
    // block chatbot errors from being reported to Sentry
    denyUrls: [/niceincontact\.com/, /amazonaws\.com/],
  };
};

export const initSentry = () => {
  Sentry.init(getSentryOptions());
};
